/**
 * @desc 后台管理角色更新
 */
import { OperationRoleForm } from '@eastcoal/api/auth/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type UpdateOperationRoleParameter = OperationRoleForm

const method = 'PUT'
const url = '/auth/operation/role'

export const updateOperationRoleApi = (
  data?: UpdateOperationRoleParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<any>({
    method,
    url,
    data,
    ...config
  })
}

updateOperationRoleApi.method = method
updateOperationRoleApi.url = url
